const
	NO_ACTION = 0,
	SELECT_AREA = 1,
	MOVE_EVENT = 2;
class Layer {

	static fromArray (data, ownerId) {
		let inst = new Layer();
		inst._id = data.id;
		inst._name = data.name;
		inst._access = data.access;
		inst._edit = data.edit;
		inst._ownerId = data.ownerId;
		inst._ownerName = data.ownerName;
		inst._ownerType = data.ownerType;

		inst.owned = data.ownerId == ownerId;
		// inst._orderBy = inst._newOrderBy = data.shift();

		return inst;
	}

	constructor (timeline) {

		this._id;
		this._name;
		this._access;
		this._edit;
		this._ownerId;
		this._ownerName;
		this._ownerType;
		this._orderBy;
		this._newOrderBy = 0;

		this.owned = true;

		this.cursorTime = null;
		this.selectStart = null;  
		this.selectEnd = null;

		this._instances = new TimelineItemList('startTime', 'endTime');

		this._movingEvents = [];
		this._movingInstances = [];
		this._moveTime = 0;

		this._views = []; // array of LayerView class
		this._viewIndex = []; // index of views by timelineId

		this._addToTimeline = timeline || false;
		this._renameDialog = null;
	}

	get id() {return this._id;}

	get name() {
		if (this.owned) return this._name;
		return `${this._name} (${this._ownerName})`;
	}

	set name(v) {
		this._name = v;
	}

	get instances () {
		return this._instances;
	}

	set ownerName (value) {
		value = value.split(' ');
		this._ownerName = value[0];
	}

	get ownerName() {
		return this._ownerName;
	}

	get isReadOnly () {return !this._edit;}

	get isActive() {
		return globalTimeline.activeLayer == this;
	}

	activate(view) {
		this.activeView = view;
		globalTimeline.activeLayer = this;
	}

	addEventInstance(instance) {
		this._instances.add(instance);
		this._views.forEach(layerView => instance.addView(layerView));
	}

	removeEventInstance(instance) {
		instance.removeViews();
		this._instances.remove(instance);
	}

	addMovingEvent(tlEvent){
		if (this._movingEvents.indexOf(tlEvent) !== -1) return;
		this._movingEvents.push(tlEvent);
	}

	removeMovingEvent(tlEvent) {
		let i = this._movingEvents.indexOf(tlEvent);
		if (i === -1) return;
		this._movingEvents.splice(i, 1);
	}

	addMovingInstance(instance) {
		this._onDrag = MOVE_EVENT;
		this._instances.remove(instance);
		this._movingInstances.push(instance);
	}

	clearMoving() {
		this._movingEvents = [];
	}

	beginMove(event) {
		this._movingInstances = [];
		this._movingEvents.forEach(tlEvent => {
			tlEvent.onMove = MOVE_BOTH;
			tlEvent.liftMovers();
		});
		this._movingEvents.forEach(tlEvent => tlEvent.mapSpaces());
		startDrag(event, this);
	}

	finishMove() {
		this._moveTime = 0;
		this._movingInstances = [];
	}

	getView (timeline, position) {
		let i = this._viewIndex.indexOf(timeline.id);
		if (i === -1) {
			i = this._viewIndex.length;
			let view = new LayerView(this, timeline, position);
			this._instances.forEach(inst => {
				inst.addView(view);
			});
			this._views.push(view);
			this._viewIndex.push(timeline.id);
		}
		return this._views[i];
	}

	mapThisSpace (instances){

		this._instances.seekTime(instances.startTime);

		let blockLeft = this._instances.prev;

		let blockRight = this._instances.item;

		return {
			'start': blockLeft ? blockLeft.endTime : 0,
			'end': blockRight ? blockRight.startTime : Infinity
		};
	}

	prepAreaSelect () {
		globalTimeline.withActivity = CREATE_NEW_EVENT;
		this._onDrag = SELECT_AREA;
		this.minSelect = this._instances.hasPrev ? this._instances.prev.endTime : 0;
		this.maxSelect = this._instances.item ? this._instances.item.startTime : Infinity;
	}

	/**
	 * 
	 * @param {EventInstance} instance 
	 * @returns {}
	 */
	getPrevSpace (instance) {
		this._instances.seekTime(instance.firstAvailableSpace.start);
		let B = this._instances.movePrev();
		let A = this._instances.movePrev();
		let loopCheck = 999;
		while (A !== false && loopCheck--) {
			if (A.endTime + instance.duration < B.startTime)
				return {'start': A.endTime, 'end': B.startTime};
			B = A;
			A = this._instances.movePrev();
		}
		if (!loopCheck) console.log('loop overrun - layer getPrevSpace');
		return {'start': 0, 'end': B.startTime};
	}

	/**
	 * 
	 * @param {EventInstance} instance 
	 * @returns {}
	 */
	getNextSpace (instance){
		this._instances.seekTime(instance.lastAvailableSpace.end);
		let A = this._instances.item;
		let B = this._instances.moveNext();
		let loopCheck = 999;
		while (B !== false && loopCheck--) {
			if (A.endTime + instance.duration < B.startTime)
				return {'start': A.endTime, 'end': B.startTime};
			A = B;
			B = this._instances.moveNext();
		}
		if (!loopCheck) console.log('loop overrun - layer getNextSpace');
		return {'start': A.endTime, 'end': Infinity};
	}

	drag(ev) {
		if (this.isReadOnly || !dragged) return;
		if (this._onDrag === SELECT_AREA) this.selectArea();
		else if (this._onDrag === MOVE_EVENT) this.moveEvents();
	}

	selectArea() {
		let tl = this.activeView?.timeline;
		let cursorTime = this.cursorTime +
			tl.pixelsToMilliseconds(dx, SNAP_DISTANCE);

		if (cursorTime < this.cursorTime) {
			this.selectStart = cursorTime < this.minSelect ? this.minSelect : cursorTime;
			this.selectEnd = this.cursorTime;
		} else {
			this.selectStart = this.cursorTime;
			this.selectEnd = this.maxSelect < cursorTime ? this.maxSelect : cursorTime;
		}

		this._views.forEach((view) => {
			let left = view.timeline.timeToOffset(this.selectStart);
			let width = view.timeline.timeToOffset(this.selectEnd) - left;
			view.updateSelectArea(left, width);
		});
	}

	moveEvents(moveTime) {
		let adjustments = [];

		if (typeof moveTime == 'undefined') {
			let tl = this.activeView?.timeline;
			moveTime = tl.pixelsToMilliseconds(dx, SNAP_DISTANCE);
		}

		this._movingInstances.forEach((instance) => {
			adjustments = adjustments.concat(instance.getAdjustments(moveTime));
		});
		adjustments = adjustments.sort((a, b) => { return Math.abs(a) - Math.abs(b); });

		if (adjustments.length) {
			outerLoop:
			for (let adj of adjustments) {
				for (let inst of this._movingInstances) {
					if (inst.adjustmentRequired(moveTime + adj)) continue outerLoop;
				}
				moveTime = moveTime + adj;
				break;
			}
		}
		this._movingEvents.forEach(tlEvent => tlEvent.move(moveTime));
		globalTimeline.updateControls();
	}

	clicked() {
		if (this.isReadOnly) return;
		this.clearSelectArea();
		if (this._onDrag === MOVE_EVENT) {
			this._movingEvents.forEach(tlEvent => tlEvent.clicked());
			this.finishMove();
		}
		this._onDrag = NO_ACTION;
	}

	dropped() {
		if (this.isReadOnly) return;
		if (this._onDrag === SELECT_AREA) {
			globalTimeline.openActivitySearchWindow();
		}
		if (this._onDrag === MOVE_EVENT) {
			this._movingEvents.forEach(tlEvent => tlEvent.dropped());
			this.finishMove();
		}
		this._onDrag = NO_ACTION;
	}

	newEvent(activity) {
		if (
			this.selectStart === null 
			|| this.selectEnd === null
			|| this.selectStart == this.selectEnd
		) return;

		TimelineEvent.fromDrag(
			this, 
			activity,
			this.selectStart, 
			this.selectEnd
		).save();
		this.clearSelectArea();
	}

	openRename () {
		if (this._renameDialog == null) {
			this._renameDialog = Dialog.Modal(`layer${this.id}-rename`, 'Rename Layer', SMALL, _('SAVE'));
			this._renameDialog.body = [
				UI.label('New Name'),
				this._newName = UI.text('')
			];
		}
		this._renameDialog.open(
			() => this.save()
		);
		this._newName.value = this._name;
		this._newName.select();
	}

	save() {
		if (this._newName.value === '') return;
		this._name = this._newName.value;

		API.upsert(
			`layers`,
			this._id,
			{
				timelineId: (this._addToTimeline ? this._addToTimeline.id : false),
				name: this._name
			}
		)
		.then(reply => {
			if (showError(reply)) return;
			if (reply.id) {
				this._id = reply.id;
				this._orderBy = reply.orderBy;
				this._edit = 1;
				this._ownerId = reply.ownerId;
				this._ownerName = reply.ownerName;
				this._ownerType = reply.ownerType;

				this._addToTimeline.manager.addLayer(this);
				this._addToTimeline.layerViews.addItem(this.getView(this._addToTimeline, this._addToTimeline.layerViews.length + 1));
			}
			this._views.forEach(view => view.name = this.name);
		});
	}

	delete() {
		Dialog.Confirm(
			_('This will delete the layer and all events. This will affect anyone the layer is shared with. <br/>This cannot be undone!'),
			_('DELETE LAYER'),
			() => {
				API.delete(
					`layers/${this.id}`
				) 
				.then(reply => {
					if (showError(reply)) return;
					window.location.reload();
				});
			}
		);
	}

	// removeFromTimeline (){
		// this._newOrderBy = 0;
		// this.save();
	// }

	clearSelectArea () {
		this.selectStart = null;
		this.selectEnd = null;
		this._views.forEach((view) => {view.updateSelectArea();});
	}

	onScaleChange() {
		this._instances.forEachInView((instance) => {instance.resize()});
	}

	update () {
		let mgr = globalTimeline;
		this._instances.updateInView(mgr.viewStartMilliseconds, mgr.viewEndMilliseconds);
		this._instances.forEachInView(inst => inst.update());
	}
}
